// extracted by mini-css-extract-plugin
export var closeButton = "_p2-2";
export var closeButtonIcon = "_p2-3";
export var lightboxContent = "_p2-1";
export var lightboxOverlay = "_p2-0";